import { faFilePdf } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Text, useMantineTheme } from '@mantine/core'
import React from 'react'

import { DisplayAsset } from '../../types/files'
import RenderReplaceWrapper from '../RenderReplaceWrapper'

const ErrorReplace = ({
  maxWidth,
  asset,
  error,
}: {
  asset: DisplayAsset
  maxWidth: string | number
  error: string
}): React.ReactElement => {
  const theme = useMantineTheme()
  return (
    <RenderReplaceWrapper backgroundColor={theme.colors.red[0]}>
      <FontAwesomeIcon
        icon={faFilePdf}
        style={{ color: theme.colors['red'][6], fontSize: 50 }}
      />

      <Box style={{ maxWidth }}>
        <Text
          size="sm"
          mt="xs"
          color="red"
          align="center"
          px="xl"
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {asset.name}
        </Text>
        <Text size="xl" mt="xs" color="red" px="xl" align="center">
          {error}
        </Text>
      </Box>
    </RenderReplaceWrapper>
  )
}

export default ErrorReplace
